/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCardLink} from '../api'

export const useMutationCreateCardLink = createReactQueryMutationHook('createCardLink', createCardLink)
